import React from 'react'

import classNames from 'classnames'

import { DynamicMapMyLocationIcon, BriefingRefreshIcon } from '@local/assets/icons'

import Clickable from '@web/ui/components/Clickable'

import styles from './CurrentLocation.module.scss'

interface Props {
  onClickRefresh?: () => void
  currentAddressLoading?: boolean
  currentAddressName?: string
  clickCode?: string
}

export default function CurrentLocation({
  currentAddressName,
  onClickRefresh,
  currentAddressLoading,
  clickCode,
}: Props) {
  const onClickRotate = () => {
    onClickRefresh?.()
  }

  return (
    <Clickable className={styles.btn_current_location} onClick={onClickRotate} nClickCode={clickCode}>
      <DynamicMapMyLocationIcon className={styles.icon_location} aria-hidden="true" />
      <div className={styles.txt_area}>
        {currentAddressLoading ? (
          '현위치를 찾고있어요.'
        ) : currentAddressName ? (
          <>
            현위치 <strong className={styles.location}>{currentAddressName}</strong>
          </>
        ) : (
          '현위치를 확인해주세요.'
        )}
      </div>
      <div className={classNames(styles.ico_area, { [styles.ani_rotate]: currentAddressLoading })}>
        <BriefingRefreshIcon className={styles.icon_refresh} aria-hidden="true" />
        <span className="place_blind">새로고침</span>
      </div>
    </Clickable>
  )
}
